import appGlobalReducer from '../slices/appGlobal.slice'

const rootReducer = {
  appGlobal: appGlobalReducer,
}

export default rootReducer
